import React from 'react';
import { Form, Input, Modal } from 'antd';
import {
  useActions,
  useEditorWatch,
  useModalActions,
  useModalState,
} from '../../provider';
import { eventNames, modalNames } from '../../config';
import { useApplyLink } from '../../hooks/useApplyLink';

const name = modalNames.link;
const Container = ({ form }) => {
  const { getFieldDecorator, validateFields, resetFields } = form;

  const { close } = useModalActions();
  const { onChange, getEditorState } = useActions();

  const { isOpen, props } = useModalState(name);
  const { url, text, editMode } = props || {};

  const applyLink = useApplyLink();

  const onCancel = () => close(name);

  const handleOk = (e) => {
    e.preventDefault();

    validateFields((err, values) => {
      if (!err) {
        const { url, text } = values;
        const textToInsert = text?.trim() || url;
        const newState = applyLink(
          { state: getEditorState(), text: textToInsert, url },
          editMode
        );
        onChange(newState);
        onCancel();
      }
    });
  };

  return (
    <Modal
      visible={isOpen}
      afterClose={resetFields}
      onCancel={onCancel}
      onOk={handleOk}
    >
      <Form>
        <TextField
          getFieldDecorator={getFieldDecorator}
          initialValue={text}
        />
        <UrlField
          getFieldDecorator={getFieldDecorator}
          initialValue={url}
        />
      </Form>
    </Modal>
  );
};

const LinkModal = Form.create({ name: 'editor-link-modal' })(Container);
export default LinkModal;

function TextField({ getFieldDecorator, initialValue = '' }) {
  const isSelectionCollapsed = useEditorWatch(
    eventNames.selectionCollapsedChange
  );

  return (
    <Form.Item label={isSelectionCollapsed ? 'Текст' : ''}>
      {getFieldDecorator('text', { initialValue })(
        <Input
          placeholder="Введите текст ссылки..."
          disabled={!isSelectionCollapsed}
          hidden={!isSelectionCollapsed}
        />
      )}
    </Form.Item>
  );
}

function UrlField({ getFieldDecorator, initialValue = '' }) {
  return (
    <Form.Item label="Ссылка">
      {getFieldDecorator('url', {
        initialValue,
        rules: [
          { required: true, message: 'Введите URL' },
          { type: 'url', message: 'Некорректный URL' },
        ],
      })(<Input placeholder="Введите URL... https://dispex.org" />)}
    </Form.Item>
  );
}
